module.exports = {
  couple: 'para',
  therapist: 'Terapeuta',
  room: 'Pokój',
  paidOn: 'Opłacone dnia',
  unpaid: 'Nieopłacone',
  hasBeen: 'Zostało',
  locked: 'zmienione',
  shifted: 'przesunięte | i przesunięte',
  hasNote: 'Posiada notatkę',
  hasSecretNote: 'Posiada sekretną notatkę',
  noP24Config: 'Nie została zakończona procedura rejestracji do przelewy24',
}
